import type { DatePickerProps } from "antd";
import { DatePicker } from "antd";
import moment from "moment";
import $ from "jquery";
import dayjs from "dayjs";
import { useGetModulesData } from "@/hooks/AllCustomHooks";
import { isNull } from "underscore";

const CampaignDurationCellRenderer: React.FC<any> = (
  {
    params,
    tillBudgetEnds,
    setTillBudgetEnds,
    duration,
    setDuration,
    identifier,
    setEquallyDivideBudget,
    isUIDisabled,
    componentConfig,
    gridParams
  }
) => {
  const isDateUpdateNotAllowed = componentConfig["end_date"].disabledTypes?.includes(params.data.program_type);

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const checkStatus = e.target.checked;
    const disabledStyle = checkStatus
      ? { pointerEvents: "none", opacity: "0.6" }
      : { pointerEvents: "all", opacity: "1" };
    setTillBudgetEnds(checkStatus);
    if(checkStatus){
      setEquallyDivideBudget(false);
      setDuration(null)
    }
    $(`#${identifier}-equally-divide-check`).prop("checked", false);
    $(`#${identifier}-budget-duration-check`).css(disabledStyle);
  };

  const datePickerChangeHandler: DatePickerProps["onChange"] = (
    date,
    dateString
  ) => {
    setDuration(dateString);
    setTillBudgetEnds(false);
  };

  const disabledDate = (current: any) => {
    if (!gridParams.isDateReduceAllowed) {
        return duration ? current && current < dayjs(params.data.end_date).startOf("day") : true;
    } else {
        return current && current < moment().startOf("day");
    }
};


  return (
    <>
      {!params?.hasPinnedColumnValue && params.node?.rowPinned ? null : (
        <div
          id={`campaign-duration-container-${identifier}`}
          className={`campaign-duration-container me-3 mt-2 ${componentConfig["till_budget_ends"].isVisible
            ? ""
            : "mb-2"
            } `}
          data-date={duration}
          data-tillBudgetEnds={tillBudgetEnds}
          style={{ display: "grid" }}
        >
          <DatePicker
            onChange={datePickerChangeHandler}
            disabledDate={disabledDate}
            disabled={
              isUIDisabled ||
              tillBudgetEnds ||
              isDateUpdateNotAllowed
            }
            defaultValue={
              !isNull(duration) ? dayjs(duration) : duration
            }
            placeholder="Select Date"
          />
          {componentConfig["end_date"].isVisible && (
            <div
              className={`${componentConfig["till_budget_ends"].isVisible
                ? "d-flex"
                : "d-none"
                } mt-1 align-items-center`}
              style={{
                lineHeight: "1.5",
                fontSize: "10px",
              }}
            >
              <input
                className="me-1"
                type="checkbox"
                name="budget-duration"
                id="budget-duration"
                onChange={handleCheckboxChange}
                checked={tillBudgetEnds}
                disabled={isUIDisabled || isDateUpdateNotAllowed}
              />
              <label className="me-1" htmlFor="budget-duration">
                {`${componentConfig["till_budget_ends"].label}`}
              </label>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default CampaignDurationCellRenderer;
